import { useState } from "react";
import {
  Typography,
  Box,
  Modal,
  Backdrop,
  CircularProgress,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const style = {
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85vw",
  bgcolor: "#ececec",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
};

export default function QuestionnaireModal({
  open,
  setOpen,
  questionnaireQuestions = [],
  loadingQuestions,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const { t } = useTranslation("questionnaires");

  const handleClose = () => {
    setOpen(false);
  };

  // console.log(
  //   "questionnaireQuestions in QuestionnaireModal: ",
  //   questionnaireQuestions
  // );
  const columns = [
    {
      field: "no",
      headerName: t("columns.no"),
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "questionTitle",
      headerName: t("columns.questionTitle"),
      flex: 3,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "answer",
      headerName: t("columns.answer"),
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "score",
    //   headerName: "Score",
    //   flex: 1,
    //   align: "center",
    //   headerAlign: "center",
    // },
  ];
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            variant="h5"
            id="parent-modal-title"
            sx={{ textAlign: "center", paddingBottom: 2 }}
          >
            {t("modal.subjectAnswersTitle", {
              id: questionnaireQuestions[0]?.subject_id,
            })}
          </Typography>
          <Typography
            variant="subtitle2"
            id="parent-modal-title"
            sx={{ textAlign: "center", paddingBottom: 2 }}
          >
            {t("modal.answeredOn", { date: questionnaireQuestions[0]?.date })}
          </Typography>
          {questionnaireQuestions ? (
            <>
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <Box sx={{ width: "100%", overflowX: "auto" }}>
                  <DataGrid
                    rows={questionnaireQuestions}
                    columns={columns}
                    filterMode="client" // Enables filtering
                    disableColumnMenu={false}
                    loading={loadingQuestions}
                    sx={{
                      // height: 500,
                      minWidth: "600px",
                      // cursor: "pointer",
                      "& .MuiDataGrid-row:hover": {
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                    pagination
                    paginationModel={{
                      pageSize: rowsPerPage,
                      page: page,
                    }}
                    onPaginationModelChange={({ page, pageSize }) => {
                      setPage(page);
                      setRowsPerPage(pageSize);
                    }}
                    pageSizeOptions={[5, 10, 20, 50]}
                  />
                </Box>
              </Paper>
            </>
          ) : (
            <Typography>{t("empty.nothingToShow")}</Typography>
          )}
        </Box>
      </Modal>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 9999,
        }}
        open={loadingQuestions}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
